export default __webpack_public_path__ + "static/media/badge-border-darkpurple@2x.06bded2c.png";